import apiClient from './apiClient';

const settingsService = {
  // Get all settings (admin only)
  getAll: async (category = null) => {
    const params = category ? { category } : {};
    const response = await apiClient.get('/settings', { params });
    return response.data;
  },

  // Get public settings (no auth required)
  getPublicSettings: async () => {
    const response = await apiClient.get('/settings/public');
    return response.data;
  },

  // Get settings grouped by category
  getCategories: async () => {
    const response = await apiClient.get('/settings/categories');
    return response.data;
  },

  // Get a specific setting by key
  getSetting: async (key) => {
    const response = await apiClient.get(`/settings/${key}`);
    return response.data;
  },

  // Create a new setting
  create: async (settingData) => {
    const response = await apiClient.post('/settings', settingData);
    return response.data;
  },

  // Update a setting
  update: async (key, settingData) => {
    const response = await apiClient.put(`/settings/${key}`, settingData);
    return response.data;
  },

  // Delete a setting
  delete: async (key) => {
    const response = await apiClient.delete(`/settings/${key}`);
    return response.data;
  },

  // Bulk update multiple settings
  bulkUpdate: async (settings) => {
    const response = await apiClient.put('/settings/bulk', { settings });
    return response.data;
  },

  // Initialize default settings
  initializeDefaults: async () => {
    const response = await apiClient.post('/settings/initialize');
    return response.data;
  }
  ,

  // Cache admin operations
  getCacheStats: async () => {
    const response = await apiClient.get('/settings/cache/stats');
    return response.data;
  },

  // Clear all cache or by pattern: { pattern: 'product:*' }
  clearCache: async (pattern = null) => {
    const body = pattern ? { pattern } : {};
    const response = await apiClient.post('/settings/cache/clear', body);
    return response.data;
  }
};

export default settingsService;
